import { RevenueSharingListPage } from "@/features/revenue-sharing/pages/RevenueSharingListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/revenue-sharing/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["revenue_sharing.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: RevenueSharingListPage,
});
